<div
    [attr.data-testid]="settings.id"
    class="w-full"
>
    <div class="h-15 items-center justify-end"
    [ngClass]="{
        'grid': !!this.settings.selectedHeader === true,
        'grid-cols-12': !!this.settings.selectedHeader === true,
        'flex': !!this.settings.selectedHeader === false,
        'flex-row': !!this.settings.selectedHeader === false,
    }"
    (click)="rowClick($event)" >
        <ng-container *ngFor="let colName of settings?.colOrder; index as i">
            <ng-container *ngFor="let col of settings?.columns | keyvalue">
                <div
                    [attr.data-testid]="settings.id + '-' + i + '-row'"
                    class="w-full overflow-x-auto overflow-y-hidden"
                    [ngClass]="{
                    'sticky':this.settings?.staticColumns && i < this.settings?.staticColumns,
                    'left-0':this.settings?.staticColumns && i < this.settings?.staticColumns,
                    'bg-white':this.settings?.staticColumns && i < this.settings?.staticColumns,
                    'px-4':this.settings?.staticColumns && i < this.settings?.staticColumns,
                    'z-10':this.settings?.staticColumns && i < this.settings?.staticColumns,
                    'my-2.5': col.value?.type === 'label',
                    'col-start-2': col.value?.type === 'label' && this.settings.selectedHeader === true,
                    'col-span-6': col.value?.type === 'label' && this.settings.selectedHeader === true,
                    'col-start-11': col.value?.type === 'action' && this.settings.selectedHeader === true,
                    'col-span-2': col.value?.type === 'action' && this.settings.selectedHeader === true,
                    'mx-auto': col.value?.type === 'action',
                    'text-right': col.value?.type === 'action',
                    'basis-1/3': col.value?.type === 'action',
                    'mx-auto': col.value?.type === 'menu',
                    'text-left': col.value?.type === 'menu',
                    'basis-1/3': col.value?.type === 'menu',
                    'basis-1/2': col.value?.type === 'select',
                    'basis-2/3': col.value?.type === 'header-sort' && col.value?.cell.label === '',
                    'relative': col.value?.type === 'graph-value',
                    'overflow-x-hidden': col.value?.type === 'graph-value',
                    'flex-row-reverse': col.value?.type === 'header-sort' &&  col.value?.cell?.align === 'right',
                    'flex': col.value?.type === 'header-sort' &&  col.value?.cell?.align === 'right',
                    'flex-row': col.value?.type === 'header-sort' &&  col.value?.cell?.align === 'left',
                    'ml-4': col.value?.cell?.longHeader === false,
                }"
                    *ngIf="colName === col.key"
                >
                    <ng-container *ngIf="col.value?.type === 'header-sort'">
                        <datiq-cell-header-sort
                            (toggled)="sortColumn($event, col)"
                            [settings]="col.value?.cell"
                        ></datiq-cell-header-sort>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'change'">
                        <datiq-cell-change
                            [settings]="col.value?.cell"
                        ></datiq-cell-change>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'label'">
                        <datiq-cell-label
                            [settings]="col.value?.cell"
                        ></datiq-cell-label>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'lane'">
                        <datiq-cell-lane
                            [settings]="col.value?.cell"
                        ></datiq-cell-lane>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'location'">
                        <datiq-cell-location
                            [settings]="col.value?.cell"
                        ></datiq-cell-location>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'title'">
                        <datiq-cell-title
                            [settings]="col.value?.cell"
                        ></datiq-cell-title>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'graph-value'">
                        <datiq-cell-graph-value
                            [settings]="col.value?.cell"
                        ></datiq-cell-graph-value>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'action'">
                        <datiq-cell-action
                            [settings]="col.value?.cell"
                            (actionClicked)="actionFired.emit($event)"
                        ></datiq-cell-action>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'menu'">
                        <datiq-cell-menu
                            [settings]="col.value?.cell"
                            (itemClicked)="actionFired.emit($event)"
                        ></datiq-cell-menu>
                    </ng-container>
                    <ng-container *ngIf="col.value?.type === 'select'">
                        <datiq-cell-select
                            [settings]="col.value?.cell"
                            (changed)="selectChange($event)"
                        ></datiq-cell-select>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
